export enum EVariables {
    Orders = 'orders_userId=',
    ORDER_STORAGE = 'order_storage_userId='
}
